import axios from 'axios'

export const apiGetAllAnalytics = () => axios.get('/api/analyticParameters/all')

export const apiSetAnalytic = (name: string, level: number, projectId: string, parentId?: string, id?: string) =>
    axios.post(`/api/analyticParameters/set`, { id, name, level, projectId, parentId })

export const apiToggleDeleteAnalytic = (id: string) => axios.post(`/api/analyticParameters/${id}/toggleIsDelete`)
